export const StyledModal = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: "600px",
		padding: "25px",
		maxHeight: "80vh",
		overflow: "hidden" as const,
		background: "#F7F8F9",
	},
	overlay: {
		backgroundColor: "rgba(15, 23, 42, 0.75)",
		backdropFilter: "blur(8px)",
		zIndex: 1000,
	},
};

export const StyledPointsModal = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: "700px",
		padding: "25px",
		maxHeight: "90vh",
		overflow: "auto" as const,
		background: "#F7F8F9",
	},
	overlay: {
		backgroundColor: "rgba(15, 23, 42, 0.75)",
		backdropFilter: "blur(8px)",
		zIndex: 1000,
	},
};

export const StyledDescriptionModal = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		minWidth: "81rem",
		maxWidth: "80vw",
		padding: "25px",
		maxHeight: "70vh",
		overflow: "hidden" as const,
		background: "#F7F8F9",
	},
	overlay: {
		backgroundColor: "rgba(15, 23, 42, 0.75)",
		backdropFilter: "blur(8px)",
		zIndex: 1000,
	},
};

export const StyledPeopleModal = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: "600px",
		padding: "2.2rem 3.3rem 9.2rem 3.3rem",
		maxHeight: "80vh",
		overflow: "hidden" as const,
		background: "#F7F8F9",
		minHeight: "40vh",
	},
	overlay: {
		backgroundColor: "rgba(15, 23, 42, 0.75)",
		backdropFilter: "blur(8px)",
		zIndex: 1000,
	},
};

export const StyledNonScrollableModal = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: "600px",
		padding: "25px",
		maxHeight: "80vh",
		overflow: "visible" as const,
		background: "#F7F8F9",
	},
	overlay: {
		backgroundColor: "rgba(15, 23, 42, 0.75)",
		backdropFilter: "blur(8px)",
		zIndex: 1000,
	},
};

// A taller variant for modals that need a bit more vertical space
export const StyledTallModal = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		width: "100%",
		maxWidth: "600px",
		padding: "25px",
		maxHeight: "92vh",
		overflow: "hidden" as const,
		background: "#F7F8F9",
	},
	overlay: {
		backgroundColor: "rgba(15, 23, 42, 0.75)",
		backdropFilter: "blur(8px)",
		zIndex: 1000,
	},
};
